import propTypes from 'prop-types';

const SvgDeviceTagIcon = ({ size, color, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 66 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34.0457 84.632C36.3941 84.5091 43.5026 83.7917 50.2545 79.6026C58.0256 74.7811 65.2834 64.9266 65.2838 53.1342C65.284 48.0418 63.4555 42.1156 60.8612 35.9805C58.3778 30.1077 55.1614 23.974 52.0873 18.1119C51.9443 17.8391 51.8015 17.5668 51.6591 17.2952C49.9097 13.9577 48.22 10.7339 46.7444 7.71835C45.4639 5.10149 43.6739 3.4875 41.392 2.54381C39.1415 1.61312 36.451 1.35086 33.3901 1.34253H33.3883L33.3141 1.34258H33.3123L33.2381 1.34273L33.2363 1.34274C30.1754 1.35106 27.4849 1.61327 25.2344 2.54391C22.9525 3.48755 21.1625 5.10148 19.882 7.71835C18.4064 10.7339 16.7166 13.9577 14.9672 17.2952C14.8248 17.5669 14.682 17.8392 14.5389 18.1121C11.4649 23.9742 8.24851 30.1078 5.76516 35.9805C3.17082 42.1156 1.34236 48.0418 1.34253 53.1342C1.34291 64.9266 8.60078 74.7811 16.3719 79.6026C23.1238 83.7917 30.2323 84.5091 32.5806 84.632V84.6537L33.2344 84.6574L33.2344 84.6574H33.2345H33.2348H33.2353L33.2369 84.6575L33.2418 84.6575L33.2587 84.6575C33.2718 84.6574 33.29 84.6573 33.3132 84.6571C33.3364 84.6573 33.3546 84.6574 33.3677 84.6575L33.3846 84.6575L33.3895 84.6575L33.391 84.6574H33.3916H33.3918H33.3919L33.392 84.6574L34.0457 84.6537V84.632Z"
        stroke={color}
        strokeOpacity="0.7"
        strokeWidth="1.31494"
      />
      <rect
        x="26.9856"
        y="9.86645"
        width="12.8023"
        height="5.59348"
        rx="2.79674"
        stroke={color}
        strokeOpacity="0.7"
        strokeWidth="1.31494"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.3879 77.3928C47.0737 77.3928 58.1681 66.2983 58.1681 52.6125C58.1681 38.9268 47.0737 27.8323 33.3879 27.8323C19.7022 27.8323 8.60772 38.9268 8.60772 52.6125C8.60772 66.2983 19.7022 77.3928 33.3879 77.3928ZM33.3879 78.5942C47.7372 78.5942 59.3696 66.9618 59.3696 52.6125C59.3696 38.2633 47.7372 26.6309 33.3879 26.6309C19.0386 26.6309 7.40625 38.2633 7.40625 52.6125C7.40625 66.9618 19.0386 78.5942 33.3879 78.5942Z"
        fill={color}
        fillOpacity="0.7"
      />
      <rect
        x="12.5149"
        y="25.511"
        width="10.9423"
        height="3.69864"
        rx="1.84932"
        transform="rotate(-59.1464 12.5149 25.511)"
        stroke={color}
        strokeOpacity="0.7"
        strokeWidth="1.31494"
      />
      <rect
        x="-0.901606"
        y="-0.227245"
        width="10.9423"
        height="3.69864"
        rx="1.84932"
        transform="matrix(-0.512846 -0.858481 -0.858481 0.512846 53.6792 24.8536)"
        stroke={color}
        strokeOpacity="0.7"
        strokeWidth="1.31494"
      />
      <path
        d="M33.1915 68.0413V64.5718L25.0613 58.6532H25.049C24.8997 58.551 24.7776 58.414 24.6933 58.2539C24.609 58.0939 24.565 57.9157 24.5652 57.7348V55.0218L33.1862 61.28V58.6409L25.056 52.7223L25.0455 52.7135L25.0209 52.6976C24.8798 52.5951 24.7648 52.4607 24.6853 52.3054C24.6058 52.1501 24.5641 51.9783 24.5634 51.8039V47.7713L33.1844 54.0313V49.587L22.6914 42.0797L22.2217 41.7612C22.1321 41.6899 22.0212 41.6508 21.9067 41.6504C21.7667 41.6504 21.6325 41.706 21.5335 41.805C21.4345 41.904 21.3789 42.0382 21.3789 42.1782V58.9628C21.3789 59.2242 21.446 59.4812 21.5738 59.7092C21.7017 59.9372 21.886 60.1285 22.109 60.2648L33.1915 68.0413Z"
        fill="#027F5D"
      />
      <path
        d="M33.1914 68.0413V64.5718L41.3233 58.6532H41.3356C41.4845 58.5507 41.6061 58.4135 41.6901 58.2535C41.7741 58.0935 41.8179 57.9155 41.8177 57.7348V55.0218L33.1967 61.28V58.6409L41.3233 52.7187L41.3339 52.7099L41.3585 52.6941C41.4994 52.5915 41.6141 52.457 41.6933 52.3017C41.7724 52.1464 41.8139 51.9747 41.8142 51.8003V47.7713L33.1932 54.0313V49.587L43.688 42.0797L44.156 41.7612C44.2461 41.6898 44.3576 41.6507 44.4726 41.6504C44.6126 41.6504 44.7469 41.706 44.8459 41.805C44.9449 41.904 45.0005 42.0382 45.0005 42.1782V58.9628C45.0002 59.2244 44.9327 59.4814 44.8045 59.7094C44.6764 59.9374 44.4918 60.1286 44.2686 60.2648L33.1914 68.0413Z"
        fill="#29AD71"
      />
    </svg>
  );
};

SvgDeviceTagIcon.propTypes = {
  size: propTypes.oneOfType([propTypes.number, propTypes.string]),
  color: propTypes.string,
};

SvgDeviceTagIcon.defaultProps = {
  size: 66,
  color: '#000',
};

export default SvgDeviceTagIcon;
